import { render, staticRenderFns } from "./InventoryRequestItemList.vue?vue&type=template&id=f7cbb470&"
import script from "./InventoryRequestItemList.vue?vue&type=script&lang=js&"
export * from "./InventoryRequestItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports